
import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell } from "recharts";

// Consistent color scheme
const COLORS = ['#0072BC', '#004880', '#34C759', '#FF3B30', '#FFCC00', '#5856D6', '#FF9500'];

interface Brand {
  name: string;
  value: number;
  percentage: number;
}

interface BrandAnalysisProps {
  brandAnalysis: Brand[];
}

const BrandAnalysis: React.FC<BrandAnalysisProps> = ({ brandAnalysis }) => {
  return (
    <section className="space-y-4">
      <h2 className="text-xl font-semibold">4. 🏷️ Merkanalyse</h2>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Verdeling per merk</CardTitle>
          <CardDescription>Aantal schadegevallen per merk</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={brandAnalysis.slice(0, 5)}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" name="Aantal" fill="#0072BC">
                  {brandAnalysis.slice(0, 5).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          
          <div className="mt-6">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Merk</TableHead>
                  <TableHead className="text-right">Aantal</TableHead>
                  <TableHead className="text-right">Percentage</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {brandAnalysis.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className="text-right">{item.value}</TableCell>
                    <TableCell className="text-right">{item.percentage}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          
          <div className="mt-4">
            <h3 className="font-medium mb-2">Feiten:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>2 merken zijn goed voor meer dan 40% van alle schade</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default BrandAnalysis;
